import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

/* Ante post and specials for now -> src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/HeadersHorseRacingNew.style.ts */
export const RaceTableCaption = withConfig(theme => styled('li', { label: 'RaceTableCaption' })`
    background: ${theme.star.raceSummary.bgColorSecondary};
    border-color: ${theme.star.raceSummary.borderColor};
    border-style: solid;
    border-width: 0 0 1px 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    @media ${theme.star.mediaQuery.tablet} {
        border-width: 0 1px 1px 1px;
    }
`);
